module.exports = __webpack_public_path__ + "static/flowmoji-FREO-merch_RGB-539b992a0f68aad066e949fb4112630a.svg";